import { FaBluesky } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const blueskyBaseSettings: SocialPlatformBaseSettings = {
  name: "Bluesky",
  icon: FaBluesky,
  fields: {
    caption: "required",
    altText: "optional",
    linkAttachment: "optional", // Link card previews
    userTags: "optional",
  },
  limits: {
    caption: 300,
    images: 4,
    videos: 1, // Assuming 1 video
    // videoDurationSeconds: ?? // Need to verify video support details
  },
  postTypes: {
    post: {},
  },
};
